import DOMPurify from 'dompurify'

export const sanitizeHtml = (html?: string) => {
    if (!html) return undefined

    return DOMPurify.sanitize(html, {
        ALLOWED_TAGS: [
            'b',
            'i',
            'em',
            'strong',
            'a',
            'p',
            'br',
            'ul',
            'ol',
            'li',
            'img',
            'h1',
            'h2',
            'h3',
            'h4',
            'h5',
            'h6'
        ],
        ALLOWED_ATTR: ['href', 'target', 'rel', 'src', 'width', 'height'],
        ALLOWED_URI_REGEXP: /^(https?|mailto|tel):/i
    })
}
